import { useEffect, useRef, useState } from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { IconColumns3, IconInfoCircle } from "@tabler/icons-react";
import { DraggableColumnList } from "./DraggableColumnList"
import { useOutsideClickHandler } from "../Utils/hooks/useOutsideClickHandler";

export const ColumnConfigurator = ({
    columnOptions,
    columns,
    setColumns,
    storageKey,      // e.g. "quotationColumns"
    visibleKey,      // e.g. "visibleQuotationColumns"
    themeColor = "#7a3a5e",
}) => {

    const [fieldSettingsShow, setFieldSettingsShow] = useState(false)
    const fieldSettingsRef = useRef(null)

    // outside click useeffect for gear dropdown filter
    useOutsideClickHandler({
        objRef: fieldSettingsRef,
        isDropdown: fieldSettingsShow,
        setDropdown: setFieldSettingsShow
    })

    const mandatoryKeys = columnOptions
        .filter(col => col.mandatory)
        .map(col => col.label);

    const allNonMandatoryKeys = columnOptions
        .filter(col => !col.mandatory)
        .map(col => col.label);

    const [tempColumns, setTempColumns] = useState(() => {
        const saved = localStorage.getItem(storageKey);

        if (saved) {
            try {
                const savedColumns = JSON.parse(saved);

                const validColumns = savedColumns.filter(key =>
                    allNonMandatoryKeys.includes(key)
                );

                return [...mandatoryKeys, ...validColumns];
            } catch {
                return [...mandatoryKeys, ...allNonMandatoryKeys];
            }
        }

        return [...mandatoryKeys, ...allNonMandatoryKeys];
    });

    useEffect(() => {
        localStorage.setItem(visibleKey, JSON.stringify(columns));
    }, [columns, visibleKey]);

    const handleCheckboxChange = (col) => {
        if (col.mandatory) return;

        setTempColumns(prev => {
            if (prev.includes(col.label)) {
                return prev.filter(key => key !== col.label);
            } else {
                const currentNonMandatory = prev.filter(
                    key => !mandatoryKeys.includes(key)
                );

                return [...mandatoryKeys, ...currentNonMandatory, col.label];
            }
        });
    };

    const handleApplyColumns = () => {
        setColumns(tempColumns);

        const nonMandatoryOrder = tempColumns.filter(
            key => !mandatoryKeys.includes(key)
        );

        localStorage.setItem(storageKey, JSON.stringify(nonMandatoryOrder));
        localStorage.setItem(visibleKey, JSON.stringify(tempColumns));
        setFieldSettingsShow(false)
    };

    return (
        <Dropdown
            as="div"
            style={{ zIndex: 101, position: "relative" }}
            className="dropdownsWithoutToggle"
            show={fieldSettingsShow}
            ref={fieldSettingsRef}
        >
            {/* <Dropdown.Toggle as={Nav.Link} className="header-link"> */}
            <button
                className="py-2 d-flex justify-content-center btn-default-outline"
                style={{
                    alignItems: "center",
                    height: "35px",
                    width: "2.5rem",
                }}
                onClick={() => {
                    setFieldSettingsShow(prev => !prev)
                }}
            >
                <FontAwesomeIcon icon={faGear} />
            </button>
            {/* </Dropdown.Toggle> */}

            <Dropdown.Menu
                className=" main-header-dropdown shadow-lg border-0 rounded-3 overflow-hidden dropdown-menu-end"
                style={{ right: "0.4rem", top: "2.5rem", width: "320px", padding: "0" }}
            >
                <style jsx>
                    {`
                    .defaultDropdownLong.dropdown-menu.show {
                        top: 0.3rem !important;
                    }
                    .bar::-webkit-scrollbar-thumb {
                        background-color: #ccc;
                        border-radius: 10px;
                    }
                    `}
                </style>
                {/* Header */}
                <div className="px-3 pt-3 pb-2 bg-light border-bottom">
                    <div className="d-flex align-items-start gap-2">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-2"
                            style={{
                                background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                                width: "34px",
                                height: "30px",
                                boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                            }}
                        >
                            {/* <i className="fa-solid fa-table-columns" style={{ fontSize: "11px" }}></i> */}
                            <IconColumns3 size={16} color="white" />

                        </div>
                        <div className="d-flex flex-column">
                            <span className="mb-0 fw-bold text-dark" style={{ fontSize: "0.95rem" }}>
                                Configure Columns
                            </span>
                            <p className="text-muted mb-0 " style={{ fontSize: "12px", marginLeft: "32px" }}>
                                Toggle visibility and drag to reorder columns.
                            </p>
                        </div>
                    </div>
                </div>

                {/* DnD List */}
                <div className="py-2">
                    <DraggableColumnList
                        columns={columnOptions}
                        tempColumns={tempColumns}
                        onCheckChange={handleCheckboxChange}
                        onReorder={(newOrder) => setTempColumns(newOrder)}
                    />
                </div>

                {/* Footer */}
                <div
                    className="bg-light border-top d-flex justify-content-between align-items-center px-3 py-2"
                >
                    <div className="text-muted d-flex align-items-center gap-1" style={{ fontSize: "12px" }}>
                        <IconInfoCircle size={16} color="#7a3a5e" />
                        <span>Drag <span className="fw-bold">⋮⋮</span> to reorder</span>
                    </div>

                    <button
                        type="button"
                        className="fw-semibold px-3 py-1 text-white border-0 shadow-sm"
                        style={{
                            fontSize: "13px",
                            borderRadius: "5px",
                            backgroundColor: "#7a3a5e",
                            transition: "all 0.2s ease"
                        }}
                        id="applyToggleColumns"
                        onClick={handleApplyColumns}
                    >
                        Apply Changes
                    </button>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
};